import { styled } from '@mui/material';

export const ViewerRoot = styled('div')({
  flexGrow: 1,
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'center',
  fontSize: 10, // for viewer's inner styles
  overflow: 'hidden',
});

export const ViewerContainer = styled('div')({
  width: '100%',
  height: '100%',
});

export const TextPopupBody = styled('div')({
  width: '15rem',
  padding: '0.5rem',
});

export const TextPopupBodyFooter = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: '0.5rem',
});

export const ViewerVersion = styled('div')({
  position: 'absolute',
  zIndex: 1,
  bottom: 0,
  right: '0.2rem',
  opacity: 0.5,
});
